import Vue from "vue"
import VTooltip from "v-tooltip"
import "./v-tooltip.sass"

Vue.use(VTooltip)
